"use client";

import {
  StarDynamic as ReactStarDynamic,
  Star as ReactStar,
  StarSolid as ReactStarSolid,
} from "./deprecated/Star";

export const StarDynamic = ReactStarDynamic;
export const Star = ReactStar;
export const StarSolid = ReactStarSolid;
